module.exports = __webpack_public_path__ + "img/part-6-info.9e3d5e40.png";